import { all, fork, put, takeLatest, call } from 'redux-saga/effects';
import { COMPANIES_MANAGEMENT_ACTION } from './actions';
import * as requests from '../../../common/helpers/HTTPRequest';
import ApiConstants from '../../../common/helpers/ApiConstants';
import { toastError } from 'src/common/helpers/Notifications';

function* getCompanies() {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.COMPANIES_MANAGEMENT}`;
    const apiRes = yield call(requests.getRequest, url, {});
    yield put({
      type: COMPANIES_MANAGEMENT_ACTION.GET_COMPANIES_SUCCESS,
      payload: apiRes,
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: COMPANIES_MANAGEMENT_ACTION.GET_COMPANIES_ERROR,
      payload: 'COMPANIES_MANAGEMENT_ACTION.GET_COMPANIES_ERROR',
    });
  }
}

export function* CompaniesManagementSaga() {
  yield takeLatest(COMPANIES_MANAGEMENT_ACTION.GET_COMPANIES, getCompanies);
}

export default function* rootSaga() {
  yield all([fork(CompaniesManagementSaga)]);
}
